import { useIntl } from '@umijs/max';
// 从 '@umijs/max' 导入国际化处理函数 useIntl

import { Button, message, notification } from 'antd';
// 从 'antd' 库导入 Button 按钮组件、message 消息组件和 notification 通知组件

import defaultSettings from '../config/defaultSettings';
// 从相对路径 '../config/defaultSettings' 导入默认设置

const { pwa } = defaultSettings;
// 从 defaultSettings 中解构出 pwa 变量，表示是否启用渐进式 Web 应用

const isHttps = document.location.protocol === 'https:';
// 判断当前访问协议是否为 HTTPS，结果存储在 isHttps 常量中

const clearCache = () => {
  // 清除所有缓存
  if (window.caches) {
    caches
      .keys()
      .then((keys) => {
        keys.forEach((key) => {
          caches.delete(key);
        });
      })
      .catch((e) => console.log(e));
  }
};

// 如果 pwa 为 true，表示启用 PWA 功能
if (pwa) {
  // 添加事件监听器，在检测到用户离线时，发送警告消息
  window.addEventListener('sw.offline', () => {
    message.warning(useIntl().formatMessage({ id: 'app.pwa.offline' }));
  });

  // 添加事件监听器，当 Service Worker 有更新时，提示用户
  window.addEventListener('sw.updated', (event: Event) => {
    const e = event as CustomEvent;
    const reloadSW = async () => {
      // 检查 ServiceWorkerRegistration 中是否有 state 为 waiting 的 sw
      // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration
      const worker = e.detail && e.detail.waiting;
      if (!worker) {
        return true;
      }

      // 使用 MessageChannel 向 waiting 状态的 SW 发送 skip-waiting 消息
      await new Promise((resolve, reject) => {
        const channel = new MessageChannel();
        channel.port1.onmessage = (msgEvent) => {
          if (msgEvent.data.error) {
            reject(msgEvent.data.error);
          } else {
            resolve(msgEvent.data);
          }
        };
        worker.postMessage({ type: 'skip-waiting' }, [channel.port2]);
      });

      clearCache(); // 清除缓存
      window.location.reload(); // 重新加载页面
      return true;
    };

    const key = `open${Date.now()}`; // 生成唯一键标识通知
    const btn = (
      <Button
        type="primary"
        onClick={() => {
          notification.destroy(key); // 销毁通知
          reloadSW(); // 重新加载 Service Worker
        }}
      >
        {useIntl().formatMessage({ id: 'app.pwa.serviceworker.updated.ok' })}
      </Button>
    );

    notification.open({
      message: useIntl().formatMessage({ id: 'app.pwa.serviceworker.updated' }), // 通知标题
      description: useIntl().formatMessage({ id: 'app.pwa.serviceworker.updated.hint' }), // 通知描述
      btn, // 按钮
      key, // 通知键
      onClose: async () => null, // 通知关闭后的操作
    });
  });
} else if ('serviceWorker' in navigator && isHttps) {
  // 如果不启用 pwa 且当前使用 https 协议，注销当前的 service worker
  const { serviceWorker } = navigator;
  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister(); // 注销所有 service worker
      });
    });
  }
  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister(); // 注销当前的 service worker
  });

  clearCache(); // 清除缓存
}
